/** @deprecated */
export const CURRENCY_CODE = '$';
export const CURRENCY = 'USD';

export const CURRENCIES = {
    USD: 'USD',
    AED: 'AED',
    THB: 'THB',
};
export const CURRENCY_LOCALES = {
    [CURRENCIES.USD]: 'en-US',
    [CURRENCIES.AED]: 'en-US',
    [CURRENCIES.THB]: 'th-TH',
};

export const CURRENCY_INPUT_CONFIG = {
    inputCurrency: {
        locale: 'en',
        currency: CURRENCY,
        currencyDisplay: 'symbol',
        precision: {
            min: 2,
            max: 4,
        },
        hideCurrencySymbolOnFocus: true,
        hideGroupingSeparatorOnFocus: true,
        hideNegligibleDecimalDigitsOnFocus: true,
        autoDecimalDigits: false,
        exportValueAsInteger: false,
        autoSign: true,
        useGrouping: true,
    },
};

export const MAX_AMOUNT = 100000000;

export const AWS_DEFAULT_CURRENCY_LOCALE = CURRENCY_LOCALES[CURRENCIES.USD];
